<template>
<Box @close="close({})" v-if="orden_compra && orden_pago">
    <template #top>Registrar Orden de Pago</template>
    <template #center>
        <div>
            <div class="nj-cols">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-subtitle-1">Orden de Pago</div>
                        <div class="nj-grid c3">
                            <InputText label="Descripción" v-model="orden_pago.opg_descripcion" :focus="true"></InputText>
                            <InputDate label="Fecha de pago programado" v-model="orden_pago.opg_fecha_pago_programado"></InputDate>
                            <InputSelect label="Pago de cierre" v-model="orden_pago.opg_pago_cierre" :source="pago_cierre" itemKey="id" itemValue="id" itemFilter="descripcion"
                                :labelFunction="(item) => item.descripcion">
                            </InputSelect>
                        </div>
                        <div class="nj-grid c3">
                            <InputSelect label="Tipo comprobante" v-model="orden_pago.tid_id" :source="tipos_documento" itemKey="tid_id" itemValue="tid_id" itemFilter="tid_descripcion"
                                :labelFunction="(item) => item.tid_descripcion">
                            </InputSelect>
                            <InputText label="Comprobante" v-model="orden_pago.opg_comprobante"></InputText>
                            <InputSelect label="Sistema de pago" v-model="orden_pago.opg_sistema_pago" :source="sistemas_pago" itemKey="id" itemValue="id" itemFilter="nombre"
                                :labelFunction="(item) => item.nombre">
                            </InputSelect>
                        </div>
                        <div class="nj-grid c3">
                            <InputText label="Monto Total" v-model="orden_compra.ord_monto_cigv" :disabled="true"></InputText>
                            <InputText label="Saldo" v-model="orden_compra.opg_saldo" :disabled="true"></InputText>
                            <InputText label="Saldo (%)" v-model="orden_compra.opg_saldo_porcentaje" :disabled="true"></InputText>
                        </div>
                        <div class="nj-grid c4">
                            <InputText type="number" label="Total" v-model="orden_pago.opg_total" @keyup="calcular()"></InputText>
                            <InputText type="number" label="Tasa detracción" v-model="tasa_detraccion" @keyup="calcular()"></InputText>
                            <InputText type="number" label="Detracción" v-model="orden_pago.opg_detraccion" :disabled="true"></InputText>
                            <InputText type="number" label="Pago" v-model="orden_pago.opg_pago" :disabled="true"></InputText>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template #bottom>
        <Upload label="Documento" v-model="pdf"></Upload>
        <Button label="Registrar" icon="save" color="green" @click="registrar()"></Button>
    </template>
</Box>
</template>

<script>
import { mapActions } from "vuex"
import { OrdenCompraService, OrdenPagoService, ResponseStatus, UsuarioService } from "../../services"
import { DateTime, Tools } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, InputDate, Help, InputSelect, InputText, InputUpload, Upload } from "../components"
import OrdenCompraData from "./OrdenCompraData.vue"
import OpcionesService from "../../services/OpcionesService"

export default {
    name: "RegistrarOrdenPago",
    components: {
        OrdenCompraData,
        InputText,
        InputSelect,
        InputUpload,
        Button,
        Upload,
        InputDate,
        Box,
        Help,
    },
    props: {
        ord_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            // * recordar definir e inicializar los atributos de los objects 
            // * para manipularlos en la interfaz
            orden_compra: null,
            orden_pago: {
                opg_creador: UsuarioService.getUsuario().usu_id,
                opg_total: null,
                opg_detraccion: null,
                opg_pago: null,
                opg_pago_cierre: null,
                opg_fecha_pago_programado: null,
            },
            pago_cierre: [],
            tipos_documento: [],
            sistemas_pago: [],
            tasa_detraccion: 0,
            pdf: null,
        }
    },
    computed: {

    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        adjuntar(opg_id) {
            this._loadingOn()
            let interval = setInterval(() => {
                OrdenPagoService
                    .adjuntar(this.pdf, opg_id)
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.close({
                                buscar_ordenes_pago: true,
                            })
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
                clearInterval(interval)
                this._loadingOff()
            }, 1000)
        },
        registrar() {
            this.orden_pago.opg_creador = UsuarioService.getUsuario().usu_id
            Tools.validate([
                this.orden_pago.opg_creador,
                this.orden_pago.opg_descripcion,
                this.orden_pago.opg_fecha_pago_programado,
                this.orden_pago.opg_total,
                this.orden_pago.opg_pago_cierre,
                this.orden_pago.opg_sistema_pago,
            ], "Falta ingresar datos para registrar la orden de pago")
            OrdenPagoService
                .registrar({
                    orden_pago: this.orden_pago
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        // * capturando el id de la orden de pago
                        if (this.pdf) {
                            this.adjuntarPdf(response.data.opg_id)
                        }
                        else {
                            this.close({
                                buscar_ordenes_pago: true,
                            })
                        }
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        close({
            interfaz = "",
            buscar_ordenes_pago = false,
            buscar_datos_orden = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar_ordenes_pago,
                buscar_datos_orden,
            })
        },
        calcular() {
            this.orden_pago.opg_detraccion = Math.round(parseFloat(this.orden_pago.opg_total).toFixed(2) * parseFloat(this.tasa_detraccion).toFixed(2))
            this.orden_pago.opg_pago = this.orden_pago.opg_total - this.orden_pago.opg_detraccion
        },
    },
    mounted() {
        // * obteniendo los tipos de documentos
        OpcionesService
            .getOpciones({
                tipo_documento: {},
                sistema_pago: {},
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.tipos_documento = response.data.tipos_documento
                    this.sistemas_pago = response.data.sistemas_pago
                    this.pago_cierre = [
                        {
                            id: "0",
                            descripcion: "No aplicar cierre"
                        },
                        {
                            id: "1",
                            descripcion: "Aplicar cierre"
                        }
                    ]
                    // * obteniendo la orden de compra
                    OrdenCompraService
                        .obtener({
                            orden_compra: {
                                ord_id: this.ord_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.orden_compra = response.data
                                this.tasa_detraccion = this.orden_compra.ori_detraccion // * obteniendo la tasa de la detracción
                                this.orden_pago.ord_id = this.orden_compra.ord_id
                                // this.orden_pago.opg_fecha_pago_programado = DateTime.getDateString()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },

}
</script>
<style scoped></style>